import { render, staticRenderFns } from "./QuestionBuilderAdminSuper.vue?vue&type=template&id=c845123a&scoped=true&lang=pug&"
import script from "./QuestionBuilderAdminSuper.vue?vue&type=script&lang=js&"
export * from "./QuestionBuilderAdminSuper.vue?vue&type=script&lang=js&"
import style0 from "./QuestionBuilderAdminSuper.vue?vue&type=style&index=0&id=c845123a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c845123a",
  null
  
)

export default component.exports